// 모바일 뒤로가기(안드로이드 버튼·iOS 스와이프·브라우저 뒤로)로 열린 다이얼로그를 닫는 공통 장치.
//
// 다이얼로그가 하나라도 열려 있으면 히스토리에 "가드" 항목을 딱 하나 쌓아 둔다(주소는 그대로).
// 뒤로가기로 가드가 빠지면 가장 위 다이얼로그만 닫고, 아직 열린 게 남아 있으면 가드를 다시 쌓는다.
// 버튼·저장 등으로 전부 닫히면 남은 가드를 조용히 걷어낸다.
//
// 가드 정리는 바로 하지 않고 잠깐 모아서(sync) 처리한다. 다이얼로그 A를 닫자마자 B를 여는 연쇄,
// React StrictMode의 이중 effect 실행에서도 히스토리가 한 칸만 유지되게 하기 위해서다.
// React Router의 히스토리 상태(idx·key)는 그대로 보존한다.

const GUARD_KEY = 'backCloseGuard';
const SYNC_DELAY = 30;

const stack = []; // 열린 순서대로 { close }
let syncTimer = null;
let ignorePops = 0; // 우리가 직접 부른 history.back()으로 생긴 popstate 수

const onGuard = () => !!window.history.state?.[GUARD_KEY];

function sync() {
  syncTimer = null;
  if (stack.length > 0 && !onGuard()) {
    window.history.pushState({ ...window.history.state, [GUARD_KEY]: true }, '');
  } else if (stack.length === 0 && onGuard()) {
    ignorePops += 1;
    window.history.back();
  }
}

function scheduleSync() {
  clearTimeout(syncTimer);
  syncTimer = setTimeout(sync, SYNC_DELAY);
}

if (typeof window !== 'undefined') {
  // 새로고침했는데 가드 위에 서 있으면 표시만 지운다(같은 주소의 평범한 항목이 된다)
  if (onGuard()) {
    const { [GUARD_KEY]: _omit, ...rest } = window.history.state;
    window.history.replaceState(rest, '');
  }

  window.addEventListener('popstate', () => {
    if (ignorePops > 0) {
      ignorePops -= 1;
      return;
    }
    if (onGuard()) {
      // 다이얼로그 안에서 다른 화면으로 이동했다가 돌아오면 남은 가드에 도착한다 → 건너뛴다
      if (stack.length === 0) {
        ignorePops += 1;
        window.history.back();
      }
      return;
    }
    const top = stack[stack.length - 1];
    if (top) {
      top.close();
      // 닫기를 거부한 다이얼로그(저장 중 등)가 남아 있으면 가드를 다시 쌓는다
      scheduleSync();
    }
  });
}

// 열린 동안 등록한다. 반환값을 호출하면 등록 해제.
export function registerBackClose(close) {
  const entry = { close };
  stack.push(entry);
  scheduleSync();
  return () => {
    const i = stack.indexOf(entry);
    if (i >= 0) stack.splice(i, 1);
    scheduleSync();
  };
}
